import { useMemo } from 'react'
import { Link } from 'react-router'
import { BookmarkBorder, Close, FolderOutlined } from '@mui/icons-material'
import { Alert, Box, Grid, IconButton, Typography } from '@mui/material'

import { useAuthentication } from '../../providers/auth-provider'
import useBookmarks from '../../utils/hooks/useBookmarks'
import useDocumentTitle from '../../utils/hooks/useDocumentTitle'
import useSharedStyles from '../../utils/shared.styles'

import useStyles from './index.styles'

const Bookmarks = () => {
  const classes = useStyles
  const sharedClasses = useSharedStyles
  const { ownUser } = useAuthentication()
  const { removeFromBookmarks } = useBookmarks()

  useDocumentTitle('Meshify Central')

  const bookmarks = useMemo(
    () =>
      ownUser?.metadata?.centralBookmarks?.sort((a, b) => {
        const aSortKey = a?.metadata?.displayName ?? String(a.id)
        const bSortKey = b?.metadata?.displayName ?? String(b.id)

        return aSortKey.localeCompare(bSortKey)
      }),
    [ownUser?.metadata?.centralBookmarks]
  )

  return (
    <Grid container={true} spacing={2}>
      <Grid size={12}>
        <Typography variant="h4">Bookmarks</Typography>
      </Grid>
      {((ownUser?.metadata && !bookmarks) || bookmarks?.length === 0) && (
        <Alert severity="info">
          <Box sx={[sharedClasses.centerContentVertical, { gap: 1 }]}>
            Click the Save icon
            <BookmarkBorder fontSize="small" />
            in the top right corner of the account to add it here
          </Box>
        </Alert>
      )}
      {bookmarks?.map((bookmark) => (
        <Grid
          key={`${bookmark.type}-${bookmark.id}`}
          container={true}
          spacing={2}
          size={12}
          sx={[sharedClasses.centerContentVertical, { flexDirection: 'row' }, classes.bookmarkContainer]}
        >
          <Grid>
            <FolderOutlined color="action" fontSize="large" />
          </Grid>
          <Grid>
            <Grid>
              <Link to={bookmark.path}>{bookmark?.metadata?.displayName ?? bookmark.path}</Link>
            </Grid>
          </Grid>
          <Grid>
            <IconButton onClick={() => removeFromBookmarks(bookmark.type, bookmark.id)} aria-label="Remove bookmark">
              <Close />
            </IconButton>
          </Grid>
        </Grid>
      ))}
    </Grid>
  )
}

export default Bookmarks
